export type DateRange = {
  from?: Date;
  to?: Date;
};

export interface InvoiceListDateFilters {
  issueFrom?: string;
  issueTo?: string;
  dueFrom?: string;
  dueTo?: string;
}

export function toInvoiceListDateFilters(issueRange: DateRange, dueRange: DateRange): InvoiceListDateFilters {
  return {
    issueFrom: issueRange.from?.toISOString(),
    issueTo: issueRange.to?.toISOString(),
    dueFrom: dueRange.from?.toISOString(),
    dueTo: dueRange.to?.toISOString(),
  };
}
